import { render, staticRenderFns } from "./jingfengLisdetal.vue?vue&type=template&id=4877d978&scoped=true"
import script from "./jingfengLisdetal.vue?vue&type=script&lang=js"
export * from "./jingfengLisdetal.vue?vue&type=script&lang=js"
import style0 from "./jingfengLisdetal.vue?vue&type=style&index=0&id=4877d978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877d978",
  null
  
)

export default component.exports